module.exports = __webpack_public_path__ + "static/media/timelapse_20.db2b266b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_20.jpg
// module id = 978
// module chunks = 0